import { Text } from '@/core/tamagoshi/Text/Text';
import { Image } from '@/domains/core/Image/Image';
import ReadMore from '@/domains/core/page/components/ReadMore/ReadMore';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { useBrand } from '@/domains/productDiscovery/ProductPage/modules/Brand/useBrand';
import {
  showLess,
  showMore,
} from '@/domains/productDiscovery/ProductPage/translations';

import { brandRedirectText, brandTitle } from './translations';

import styles from './BrandBlock.module.scss';

export const onShowMore = () => Gtm.push({ event: 'unfold_brand_description' });

export const BrandBlock = () => {
  const { id, name, description, url, imageUrl } = useBrand();
  if (!name || !description) return null;

  return (
    <>
      <div className={styles.title}>{brandTitle}</div>
      {url && imageUrl && (
        <a
          href={url}
          data-testid={`brand-logo-link-${id}`}
          className={styles.brandLink}
        >
          <Image
            src={imageUrl}
            alt={name}
            loading="lazy"
            width={120}
            height={40}
            className={styles.brandImage}
          />
          <Text weight="semiBold" className={styles.brandRedirectText}>
            {brandRedirectText.format({ brand: name })}
          </Text>
        </a>
      )}
      <div className={styles.body}>
        <ReadMore
          textClassName={styles.readMore}
          onShowMore={onShowMore}
          textLess={showLess}
          textMore={showMore}
        >
          {/* eslint-disable react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: description }} />
          {/* eslint-enable react/no-danger */}
        </ReadMore>
      </div>
    </>
  );
};

BrandBlock.displayName = 'BrandBlock';
